/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notif_Push_DisableInputs */

const vi_notif_push_disable = /** @type {(inputs: Notif_Push_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tắt thông báo đẩy`)
};

/**

* @param {Notif_Push_DisableInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const notif_push_disable = /** @type {((inputs?: Notif_Push_DisableInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notif_Push_DisableInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_notif_push_disable(inputs)
});